import { Injectable } from '@angular/core';
import {
  ApiCallHandler,
  EoHttpClient,
  IDataService,
  IHttpParams,
  PaginatedSearchResult,
} from 'ngx-eo-web-components';
import { CoreService } from '../../modules/core/core.service';
import { Observable } from 'rxjs';
import { ISortParams } from '../../modules/shared/models/sort.model';
import { SurgeryAssignment } from '../../modules/core/models/surgery-assignment.model';

@Injectable({
  providedIn: 'root',
})
export class SurgeryAssignmentService
  implements IDataService<SurgeryAssignment>
{
  constructor(private http: EoHttpClient, private coreService: CoreService) {}
  public searchCh =
    new ApiCallHandler<PaginatedSearchResult<SurgeryAssignment> | null>();

  public surgeryAssignmentListCallHandler = new ApiCallHandler<
    SurgeryAssignment[]
  >();
  public surgeryAssignmentListByHospitalCallHandler = new ApiCallHandler<
    SurgeryAssignment[]
  >();

  public surgeryAssignmentFetchCallHandler =
    new ApiCallHandler<SurgeryAssignment>();

  public surgeriesCountCallHandler = new ApiCallHandler<number>();

  public surgeryAssignmentSaveCallHandler =
    new ApiCallHandler<SurgeryAssignment | null>();
  public surgeryAssignmentUpdateCallHandler =
    new ApiCallHandler<SurgeryAssignment | null>();
  public surgeryAssignmentDeleteCallHandler =
    new ApiCallHandler<SurgeryAssignment | null>();

  init() {
    this.surgeryAssignmentListCallHandler.init([]);
    this.surgeryAssignmentListByHospitalCallHandler.init([]);

    this.surgeryAssignmentFetchCallHandler.init();
    this.surgeryAssignmentSaveCallHandler.init(null);
    this.surgeryAssignmentUpdateCallHandler.init(null);
    this.surgeryAssignmentDeleteCallHandler.init(null);
    this.surgeriesCountCallHandler.init(0);
    this.searchCh.init();
  }

  getAllSurgeryAssignments() {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/SurgeryAssignments/list`,
      this.surgeryAssignmentListCallHandler
    );

    return this.http.get<SurgeryAssignment[]>(param);
  }

  getSurgeryAssignmentsByHospital(hospitalId: string) {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/SurgeryAssignments/list/${hospitalId}`,
      this.surgeryAssignmentListByHospitalCallHandler
    );

    return this.http.get<SurgeryAssignment[]>(param);
  }


  getSurgeryAssignmentById(surgeryAssignmentId: string) {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/SurgeryAssignments/fetch/${surgeryAssignmentId}`,
      this.surgeryAssignmentFetchCallHandler
    );

    return this.http.get<SurgeryAssignment>(param);
  }

  getSurgeryAssignmentByHospitalAndDate(
    hospitalId: string,
    month: number,
    year: number
  ) {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/SurgeryAssignments/fetch/${hospitalId}/${month}/${year}`,
      this.surgeryAssignmentFetchCallHandler
    );

    return this.http.get<SurgeryAssignment>(param);
  }


  getSurgeriesCount(
    hospitalId: string,
    month: number,
    year: number
  ) {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/SurgeryAssignments/count/${hospitalId}/${month}/${year}`,
      this.surgeriesCountCallHandler
    );

    return this.http.get<number>(param);
  }

  getSurgeriesCountWithClinic(
    hospitalId: string,
    month: number,
    year: number,
    clinicId?: string
  ) {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/SurgeryAssignments/count/${hospitalId}/${month}/${year}/${clinicId}`,
      this.surgeriesCountCallHandler
    );

    return this.http.get<number>(param);
  }


 
  searchSurgeryAssignments(
    searchParams: {
      HospitalID?: string | null;
      SortParams?: ISortParams | null;
    } = { HospitalID: null, SortParams: null },
    pagesize: number,
    page: number
  ): Observable<PaginatedSearchResult<SurgeryAssignment>> {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/SurgeryAssignments/search/${pagesize}/${page}`,
      this.searchCh,
      searchParams
    );

    return this.http.post<PaginatedSearchResult<SurgeryAssignment>>(param);
  }

  saveSurgeryAssignment(surgeryAssignment: SurgeryAssignment) {
    const param: IHttpParams = this.coreService.initCall(
      '/v1/SurgeryAssignments/save',
      this.surgeryAssignmentSaveCallHandler,
      surgeryAssignment
    );
    return this.http.post(param);
  }

  updateSurgeryAssignment(surgeryAssignment: SurgeryAssignment) {
    const param: IHttpParams = this.coreService.initCall(
      '/v1/SurgeryAssignments/update',
      this.surgeryAssignmentUpdateCallHandler,
      surgeryAssignment
    );
    return this.http.put(param);
  }

  deleteSurgeryAssignment(surgeryAssignmentId: string) {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/SurgeryAssignments/delete/${surgeryAssignmentId}`,
      this.surgeryAssignmentDeleteCallHandler
    );
    return this.http.delete(param);
  }



}
